import * as React from "react";
import gql from "graphql-tag";
import { ChildProps, graphql } from "react-apollo";
import { RouteComponentProps, withRouter } from "react-router";

import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";
import withPagination, { PaginationProps } from "app/utils/withPagination";
import ConfigurableTable from "app/components/AppComponents/ConfigurableTable";

import {
  columnConfigFactory,
  GqlRefundRequest,
} from "app/components/AppComponents/RefundRequests/refundRequestsColumns";

type GqlData = {
  refund_request: Array<GqlRefundRequest>;
};

type Props = ChildProps<
  {
    id: string;
    name: string;
    created_at_from: string;
    status: string;
  } & RouteComponentProps &
    PaginationProps,
  GqlData
>;

class AllRefundRequestsContainer extends React.Component<Props> {
  onReload() {
    this.props.data.refetch();
  }

  render() {
    return (
      <BOGraphQLLoader data={this.props.data}>
        <ConfigurableTable
          name={this.props.name}
          history={this.props.history}
          pagination={this.props.pagination}
          columnConfigs={columnConfigFactory()}
          defaultColumns={[
            "Date created",
            "Original payment",
            "Status",
            "Amount",
          ]}
          rows={this.props.data.refund_request || []}
          rowToLink={(refund: GqlRefundRequest) =>
            `/snapscan/ops/refund_requests/${refund.id}/summary`
          }
        />
      </BOGraphQLLoader>
    );
  }
}

const refundRequestListGql = gql`
  query AllRefunds(
    $id: String
    $offset: Int
    $limit: Int
    $created_at_from: String
    $status: String
  ) {
    refund_request(
      id: $id
      offset: $offset
      limit: $limit
      created_at_from: $created_at_from
      status: $status
    ) {
      id
      amount
      comments
      created_at
      original_payment_id
      status
      updated_at
      original_payment {
        reference
      }
      refund_payment {
        reference
      }
    }
  }
`;

const withRefundRequestGqlData = graphql<GqlData, Props>(refundRequestListGql, {
  options: (props) => {
    const {
      id,
      status,
      created_at_from,
      pagination: { offset, limit },
    } = props;

    return {
      fetchPolicy: "network-only",
      variables: {
        id,
        status,
        created_at_from,
        offset,
        limit,
      },
    };
  },
});

export default withPagination(
  withRouter(withRefundRequestGqlData(AllRefundRequestsContainer))
);
